
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courts",
      function () {
        return require("private-next-pages/courts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courts"])
      });
    }
  